/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement } from 'react';
import ButtonContainer from '../components/layout/ButtonContainer';
import StyledButton from '../components/styled/StyledButton';

interface BottomButtonNavigationProps {
    onNextClick: () => void;
    nextDisabled: boolean;
    nextButtonText?: string;
    onBackClick?: () => void;
}

export default function BottomButtonNavigation({
    onBackClick,
    onNextClick,
    nextDisabled,
    nextButtonText = 'Next',
}: BottomButtonNavigationProps): ReactElement {
    return (
        <ButtonContainer>
            {onBackClick && (
                <StyledButton
                    variant={'secondary'}
                    onClick={onBackClick}
                    buttonStyle={{ minWidth: 140 }}
                >
                    Back
                </StyledButton>
            )}
            <StyledButton
                variant={'primary'}
                disabled={nextDisabled}
                onClick={onNextClick}
                buttonStyle={{ minWidth: 140 }}
            >
                {nextButtonText}
            </StyledButton>
        </ButtonContainer>
    );
}
